var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCleanTable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6285_869",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333252 0.333413H13.6666V13.6667H0.333252V0.333413Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6285_869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6742 9.16992L4.86792 3.3637L5.53821 2.69338C6.13782 2.0938 7.10995 2.0938 7.70956 2.69338L11.3445 6.32828C11.9441 6.92789 11.9441 7.90003 11.3445 8.49964L10.6742 9.16992Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0889 5.07275L8.91821 3.90213L11.8754 0.944915C12.1818 0.638561 12.6785 0.638561 12.9849 0.944915L13.0461 1.00611C13.3524 1.31247 13.3524 1.80921 13.0461 2.11557L10.0889 5.07275Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04656 9.73659L6.57708 13.2671C6.54862 12.1654 7.5207 11.1528 8.50028 10.1733C8.88953 9.78402 9.49752 9.17602 10.089 8.58456L5.40643 3.90201C4.81497 4.49347 4.20695 5.10146 3.81771 5.49071C2.83812 6.47029 1.82557 7.44235 0.723877 7.41391L1.8945 8.58454L3.26997 8.37972L3.04656 9.73659Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCleanTable);
export default __webpack_public_path__ + "static/media/cleanTable.828297a8e1aaf5705824490ae5d703b9.svg";
export { ForwardRef as ReactComponent };